import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';


/*************************************************************/

/**
 * @type {class}
 * @desc AuthFlowMemberVerificationStep defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { AuthFlowMemberVerificationStepService } from 'services/authFlowMemberVerificationStep';
 *
 * // create service instance and send/cancel request
 * const authFlowMemberVerificationStepService = new AuthFlowMemberVerificationStepService();
 * const result = await authFlowMemberVerificationStepService.fetchData( '<user-id>' ); // fetch data
 * authFlowMemberVerificationStepService.cancel(); // cancel an active request
 */
export class AuthFlowMemberVerificationStepService extends HttpService {

    // make request and fetch component data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract data
            const visibility = get( response, 'body.component.visibility', {} );
            const widgets = get( response, 'body.component.structure.widgets', [] );
            const navActions = get( response, 'body.component.structure.navActions', [] );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    widgets: getVisibleItems( widgets, visibility ),
                    navActions: getVisibleItems( navActions, visibility ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
